<h1>{{ title.getTitle() }}</h1>
<hr />
<div id="addContent" class="hide-on-print">
  <div id="actionElements">
    <ng-container>
      <a (click)="openModal()" class="btn btn-save btn-sm inline-add-btn mt-2">Add Letter Code </a>
    </ng-container>
  </div>
</div>
<pcg-table
  #table
  [dataSource]="dataSource"
  [pcgSort]="[['letterCodeId', 'asc']]"
  [columnDefs]="columns"
  [canResetFilters]="true"
  uniqueColumn="letterCodeName"
  identificationColumn="letterCodeId"
  >
  <ng-container cdkColumnDef="letterCodeName">
    <th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>
      {{ columns.get('letterCodeName').displayName }}
    </th>
    <td
      cdk-cell
      *cdkCellDef="let row"
      [attr.data-label]="columns.get('letterCodeName').displayName"
      style="white-space: nowrap"
      >
      <pcg-edit-link (click)="openModal(row.letterCodeId, row.letterCodeName)">{{
        row.letterCodeName
      }}</pcg-edit-link>
    </td>
  </ng-container>

  <ng-container cdkColumnDef="canDelete">
    <th cdk-header-cell *cdkHeaderCellDef>
      {{ columns.get('canDelete').displayName }}
    </th>
    <td cdk-cell *cdkCellDef="let row" [attr.data-label]="columns.get('canDelete').displayName">
      <pcg-delete-button
        [table]="table"
        [confirmMessage]="'Are you sure you want to delete this letter code?'"
        [url]="deleteUrl"
        [id]="row.letterCodeId"
        >
      </pcg-delete-button>
    </td>
  </ng-container>
</pcg-table>

<ng-template #createLetterCode let-modal>
  <form
    [formGroup]="letterCodeFormGroup"
    pcgSubmitUrl="api/Clients/Client/SaveNewLetterCode"
    (messageReceive)="reloadTable(); modal.dismiss()"
    >
    <div class="modal-header">
      <h5 class="modal-title" id="modal-basic-title">Create Letter Code</h5>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <pcg-control-group label="Letter Code">
        <input pcgControlRef class="form-control" type="text" formControlName="letterCodeName" />
      </pcg-control-group>
    </div>

    <pcg-fixed-buttons>
      <a class="btn btn-cancel btn-lg" (click)="modal.dismiss()">Cancel</a>
      @if (letterCodeId !== 0) {
        <button type="submit" class="btn btn-save btn-lg">Save Changes</button>
      }
      @if (letterCodeId === 0) {
        <button type="submit" class="btn btn-save btn-lg">Save</button>
      }
    </pcg-fixed-buttons>
  </form>
</ng-template>
